import { render } from "./ResidentialFAQ.vue?vue&type=template&id=420d0921"
const script = {}

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__